<template>
  <div class="labeled-date-input">
    <InputLabel
      :input-id="inputId"
      :label="label"
      :required-icon="requiredIcon"
      :tooltip="tooltip"
    />
    <DateInput
      ref="dateInput"
      :id="inputId"
      :size="size"
      :is-disabled="isDisabled"
      :type="type"
      :value="value"
      :placeholder="placeholder"
      :default-display-date="defaultDisplayDate"
      :range="range"
      :events="events"
      :holidays="holidays"
      :disabled-dates="disabledDates"
      :available-dates="availableDates"
      :disabled-past-dates="disabledPastDates"
      :min-date="minDate"
      :start-year="startYear"
      :end-year="endYear"
      :icon-color="iconColor"
      :error-messages="errorMessages"
      v-on="$listeners"
      v-bind="$attrs"
    />
  </div>
</template>

<script>
import DateInput from '../date-input';
import InputLabel from '../label';
import { RandomId } from '@/shared/lib/random';

const { generateRandomId } = RandomId();

export default {
  model: {
    prop: 'value',
    event: 'input'
  },
  props: {
    label: {
      type: String,
      default: '',
    },
    requiredIcon: {
      type: Boolean,
      default: false,
    },
    tooltip: {
      type: Object,
      default: null,
    },
    size: {
      type: String,
      default: 'small',
      validator: (value) => ['normal', 'small'].includes(value)
    },
    isDisabled: {
      type: Boolean,
      default: false
    },
    type: {
      type: String,
      enum: ['select', 'input'],
      default: 'select',
    },
    value: {
      type: [String, Date, Object, Array],
      default: null,
    },
    placeholder: {
      type: String,
      default: 'Select date',
    },
    format: {
      type: String,
      default: 'DD.MM.YYYY',
    },
    defaultDisplayDate: {
      type: [String, Date, Object],
      default: null,
    },
    range: {
      type: Boolean,
      default: false,
    },
    events: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((event) => event.date),
    },
    holidays: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((holiday) => holiday.date),
    },
    disabledDates: {
      type: Array,
      default: () => [],
      validator: (value) => value.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    availableDates: {
      type: Array,
      default: () => [],
      validator: (value) => value?.every((item) => {
        return item && (typeof item === 'string' || item instanceof Date || (typeof item === 'object' && item.date));
      }),
    },
    disabledPastDates: {
      type: Boolean,
      default: false,
    },
    minDate: {
      type: [String, Date, Object],
      default: null,
    },
    startYear: {
      type: Number,
      default: null,
    },
    endYear: {
      type: Number,
      default: null,
    },
    iconColor: {
      type: String,
      default: '#71717A',
    },
    errorMessages: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inputId: `input-date-${this.generateRandomId()}`,
    };
  },
  computed: {
    getDateInput() {
      return this.$refs.textInput;
    }
  },
  components: { InputLabel, DateInput },
  methods: {
    generateRandomId,
  },
};
</script>
